// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adaptive-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
  cursor: pointer;
  animation: fadeIn 0.2s ease-out;
}

.adaptive-modal-side-panel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 1050;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 25px rgba(0, 0, 0, 0.15);
  animation: slideInRight 0.3s ease-out;
}
.adaptive-modal-side-panel.adaptive-modal-sm {
  width: 400px;
}
.adaptive-modal-side-panel.adaptive-modal-md {
  width: 520px;
}
.adaptive-modal-side-panel.adaptive-modal-lg {
  width: 650px;
}
.adaptive-modal-side-panel.adaptive-modal-xl {
  width: 800px;
}
@media (max-width: 768px) {
  .adaptive-modal-side-panel {
    display: none;
  }
}

.adaptive-modal-bottom-sheet {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-height: 85vh;
  background-color: #fff;
  z-index: 1050;
  display: none;
  flex-direction: column;
  border-radius: 1rem 1rem 0 0;
  box-shadow: 0 -4px 25px rgba(0, 0, 0, 0.15);
  animation: slideInUp 0.3s ease-out;
  transition: transform 0.1s ease-out;
}
@media (max-width: 768px) {
  .adaptive-modal-bottom-sheet {
    display: flex;
  }
}
.adaptive-modal-bottom-sheet.dragging {
  transition: none;
}

.adaptive-modal-handle {
  width: 40px;
  height: 4px;
  background-color: #dee2e6;
  border-radius: 2px;
  margin: 0.75rem auto 0;
  flex-shrink: 0;
  cursor: grab;
  touch-action: none;
}
.adaptive-modal-handle:active {
  cursor: grabbing;
}

.adaptive-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e9ebec;
  background-color: #f3f6f9;
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .adaptive-modal-header {
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #e9ecef;
  }
}

.adaptive-modal-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
}
@media (max-width: 768px) {
  .adaptive-modal-title {
    color: #212529;
  }
}

.adaptive-modal-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 4px;
  color: #878a99;
  font-size: 1.25rem;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
}
.adaptive-modal-close:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #405189;
}
.adaptive-modal-close:active {
  transform: scale(0.95);
}
@media (max-width: 768px) {
  .adaptive-modal-close {
    background-color: #f3f3f9;
    border-radius: 50%;
    color: #6c757d;
  }
  .adaptive-modal-close:hover {
    background-color: #e9ecef;
  }
}

.adaptive-modal-body {
  flex: 1 1;
  padding: 1.25rem;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  min-height: 0;
}
.adaptive-modal-body::-webkit-scrollbar {
  width: 5px;
}
.adaptive-modal-body::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.adaptive-modal-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
.adaptive-modal-body::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}
@media (max-width: 768px) {
  .adaptive-modal-body {
    padding: 1rem;
    padding-bottom: calc(1rem + env(safe-area-inset-bottom, 0));
  }
}

.adaptive-modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 1rem 1.25rem;
  border-top: 1px solid #e9ebec;
  background-color: #f3f6f9;
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .adaptive-modal-footer {
    padding: 0.75rem 1rem;
    padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0));
    border-top: 1px solid #e9ecef;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes slideInUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
.adaptive-modal-bottom-sheet.dragging {
  user-select: none;
  -webkit-user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Common/AdaptiveModal.scss"],"names":[],"mappings":"AAMA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,eAAA;EACA,+BAAA;AALF;;AAYA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,2CAAA;EACA,qCAAA;AATF;AAYE;EACE,YAAA;AAVJ;AAaE;EACE,YAAA;AAXJ;AAcE;EACE,YAAA;AAZJ;AAeE;EACE,YAAA;AAbJ;AAiBE;EA9BF;IA+BI,aAAA;EAdF;AACF;;AAqBA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,2CAAA;EACA,kCAAA;EACA,mCAAA;AAlBF;AAoBE;EAhBF;IAiBI,aAAA;EAjBF;AACF;AAmBE;EACE,gBAAA;AAjBJ;;AAsBA;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AAnBF;AAqBE;EACE,gBAAA;AAnBJ;;AA2BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,gCAAA;EACA,yBAAA;EACA,cAAA;AAxBF;AA2BE;EAVF;IAWI,qBAAA;IACA,gCAAA;EAxBF;AACF;;AA2BA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAxBF;AA0BE;EANF;IAOI,cAAA;EAvBF;AACF;;AA0BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,cAAA;AAvBF;AAyBE;EACE,qCAAA;EACA,cAAA;AAvBJ;AA0BE;EACE,sBAAA;AAxBJ;AA2BE;EAzBF;IA0BI,yBAAA;IACA,kBAAA;IACA,cAAA;EAxBF;EA0BE;IACE,yBAAA;EAxBJ;AACF;;AAgCA;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,aAAA;AA7BF;AAgCE;EACE,UAAA;AA9BJ;AAiCE;EACE,mBAAA;AA/BJ;AAkCE;EACE,mBAAA;EACA,kBAAA;AAhCJ;AAkCI;EACE,mBAAA;AAhCN;AAqCE;EA3BF;IA4BI,aAAA;IAEA,2DAAA;EAnCF;AACF;;AA0CA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAAA;AAvCF;AA0CE;EAXF;IAYI,qBAAA;IACA,8DAAA;IACA,6BAAA;EAvCF;AACF;;AA8CA;EACE;IACE,UAAA;EA3CF;EA6CA;IACE,UAAA;EA3CF;AACF;AA8CA;EACE;IACE,2BAAA;EA5CF;EA8CA;IACE,wBAAA;EA5CF;AACF;AA+CA;EACE;IACE,2BAAA;EA7CF;EA+CA;IACE,wBAAA;EA7CF;AACF;AAqDA;EACE,iBAAA;EACA,yBAAA;AAnDF","sourcesContent":["// AdaptiveModal - Desktop: Side Modal, Mobile: Bottom Sheet\n\n// =============================================\n// BACKDROP (Shared)\n// =============================================\n\n.adaptive-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1040;\n  cursor: pointer;\n  animation: fadeIn 0.2s ease-out;\n}\n\n// =============================================\n// DESKTOP: SIDE MODAL (768px+)\n// =============================================\n\n.adaptive-modal-side-panel {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #fff;\n  z-index: 1050;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -4px 0 25px rgba(0, 0, 0, 0.15);\n  animation: slideInRight 0.3s ease-out;\n\n  // Size variants\n  &.adaptive-modal-sm {\n    width: 400px;\n  }\n\n  &.adaptive-modal-md {\n    width: 520px;\n  }\n\n  &.adaptive-modal-lg {\n    width: 650px;\n  }\n\n  &.adaptive-modal-xl {\n    width: 800px;\n  }\n\n  // Mobile: hide side panel, show bottom sheet instead\n  @media (max-width: 768px) {\n    display: none;\n  }\n}\n\n// =============================================\n// MOBILE: BOTTOM SHEET (max-width: 768px)\n// =============================================\n\n.adaptive-modal-bottom-sheet {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  max-height: 85vh;\n  background-color: #fff;\n  z-index: 1050;\n  display: none;\n  flex-direction: column;\n  border-radius: 1rem 1rem 0 0;\n  box-shadow: 0 -4px 25px rgba(0, 0, 0, 0.15);\n  animation: slideInUp 0.3s ease-out;\n  transition: transform 0.1s ease-out;\n\n  @media (max-width: 768px) {\n    display: flex;\n  }\n\n  &.dragging {\n    transition: none;\n  }\n}\n\n// Drag Handle (Mobile Only)\n.adaptive-modal-handle {\n  width: 40px;\n  height: 4px;\n  background-color: #dee2e6;\n  border-radius: 2px;\n  margin: 0.75rem auto 0;\n  flex-shrink: 0;\n  cursor: grab;\n  touch-action: none;\n\n  &:active {\n    cursor: grabbing;\n  }\n}\n\n// =============================================\n// HEADER (Shared)\n// =============================================\n\n.adaptive-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid #e9ebec;\n  background-color: #f3f6f9;\n  flex-shrink: 0;\n\n  // Mobile: adjust padding for bottom sheet\n  @media (max-width: 768px) {\n    padding: 0.75rem 1rem;\n    border-bottom: 1px solid #e9ecef;\n  }\n}\n\n.adaptive-modal-title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #495057;\n\n  @media (max-width: 768px) {\n    color: #212529;\n  }\n}\n\n.adaptive-modal-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  border-radius: 4px;\n  color: #878a99;\n  font-size: 1.25rem;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n    color: #405189;\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  @media (max-width: 768px) {\n    background-color: #f3f3f9;\n    border-radius: 50%;\n    color: #6c757d;\n\n    &:hover {\n      background-color: #e9ecef;\n    }\n  }\n}\n\n// =============================================\n// BODY (Shared)\n// =============================================\n\n.adaptive-modal-body {\n  flex: 1;\n  padding: 1.25rem;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n  min-height: 0; // Important for flex children to shrink\n\n  // Custom scrollbar (Desktop)\n  &::-webkit-scrollbar {\n    width: 5px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 3px;\n\n    &:hover {\n      background: #a1a1a1;\n    }\n  }\n\n  // Mobile: adjust padding\n  @media (max-width: 768px) {\n    padding: 1rem;\n    // Add safe area for notch/bottom bar\n    padding-bottom: calc(1rem + env(safe-area-inset-bottom, 0));\n  }\n}\n\n// =============================================\n// FOOTER (Shared)\n// =============================================\n\n.adaptive-modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  padding: 1rem 1.25rem;\n  border-top: 1px solid #e9ebec;\n  background-color: #f3f6f9;\n  flex-shrink: 0;\n\n  // Mobile: adjust padding and add safe area\n  @media (max-width: 768px) {\n    padding: 0.75rem 1rem;\n    padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0));\n    border-top: 1px solid #e9ecef;\n  }\n}\n\n// =============================================\n// ANIMATIONS\n// =============================================\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideInUp {\n  from {\n    transform: translateY(100%);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n\n// =============================================\n// UTILITY CLASSES\n// =============================================\n\n// Prevent text selection during drag\n.adaptive-modal-bottom-sheet.dragging {\n  user-select: none;\n  -webkit-user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
